import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengesmilo() {
  return (
    <section className="challengesmilo p-100 text_milo">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Project <span>Challenges</span>
            </h2>
            <p>
              MiloCare+ came across two daunting challenges during development
              phase. Initially, integrating the app with Apple and Google
              Wallets presented difficulties, requiring a custom solution for
              users to steadily store their vaccination cards digitally.
            </p>
            <p>
              Moreover, protecting the utmost data security and privacy was of
              top concern due to the delicate nature of health records.
              Resolving these issues was imperious to deliver a reliable and
              secure health record management tool.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="client_img">
              <StaticImage
                src="../../../images/case-studies/milocare/challenges.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={646}
                height={608}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengesmilo;
